import {Types} from 'mongoose';
import * as cr from './dispossition-conflict-resolutions.const';
import * as ids from './dispossitions.const';

//  --- Conflict Resolution
//  ------ Mediation
export const CR_ME_OPEN_PENDING = {...cr.CR_ME_OPEN_PENDING, _id: new Types.ObjectId(ids.CR_ME_OPEN_PENDING_ID)};
export const CR_ME_FULL_AGREEMENT = {...cr.CR_ME_FULL_AGREEMENT, _id: new Types.ObjectId(ids.CR_ME_FULL_AGREEMENT_ID)};
export const CR_ME_NO_AGREEMENT = {...cr.CR_ME_NO_AGREEMENT, _id: new Types.ObjectId(ids.CR_ME_NO_AGREEMENT_ID)};
export const CR_ME_PARTIAL_AGREEMENT = {
    ...cr.CR_ME_PARTIAL_AGREEMENT,
    _id: new Types.ObjectId(ids.CR_ME_PARTIAL_AGREEMENT_ID),
};
export const CR_ME_NO_CONTACT = {...cr.CR_ME_NO_CONTACT, _id: new Types.ObjectId(ids.CR_ME_NO_CONTACT_ID)};
export const CR_ME_TOO_FEW_PARTIES = {
    ...cr.CR_ME_TOO_FEW_PARTIES,
    _id: new Types.ObjectId(ids.CR_ME_TOO_FEW_PARTIES_ID),
};
export const CR_ME_CANCELED_NO_SHOW = {
    ...cr.CR_ME_CANCELED_NO_SHOW,
    _id: new Types.ObjectId(ids.CR_ME_CANCELED_NO_SHOW_ID),
};
export const CR_ME_DECLINED = {...cr.CR_ME_DECLINED, _id: new Types.ObjectId(ids.CR_ME_DECLINED_ID)};
export const CR_ME_WITHDRAWN = {...cr.CR_ME_WITHDRAWN, _id: new Types.ObjectId(ids.CR_ME_WITHDRAWN_ID)};
export const CR_ME_DISCONTINUED = {...cr.CR_ME_TOO_FEW_PARTIES, _id: new Types.ObjectId(ids.CR_ME_DISCONTINUED_ID)};
export const CR_ME_INAPPROPRIATE = {...cr.CR_ME_INAPPROPRIATE, _id: new Types.ObjectId(ids.CR_ME_INAPPROPRIATE_ID)};
export const CR_ME_LIMITED_RESOURCES_MEDIATOR = {
    ...cr.CR_ME_LIMITED_RESOURCES_MEDIATOR,
    _id: new Types.ObjectId(ids.CR_ME_LIMITED_RESOURCES_MEDIATOR_ID),
};
export const CR_ME_LIMITED_RESOURCES_INTERPRETER = {
    ...cr.CR_ME_LIMITED_RESOURCES_INTERPRETER,
    _id: new Types.ObjectId(ids.CR_ME_LIMITED_RESOURCES_INTERPRETER_ID),
};
export const CR_ME_LIMITED_RESOURCES_TECHNOLOGY = {
    ...cr.CR_ME_LIMITED_RESOURCES_TECHNOLOGY,
    _id: new Types.ObjectId(ids.CR_ME_LIMITED_RESOURCES_TECHNOLOGY_ID),
};
export const CR_ME_LIMITED_RESOURCES_SPACE = {
    ...cr.CR_ME_LIMITED_RESOURCES_SPACE,
    _id: new Types.ObjectId(ids.CR_ME_LIMITED_RESOURCES_SPACE_ID),
};
export const CR_ME_LIMITED_RESOURCES_OTHER = {
    ...cr.CR_ME_LIMITED_RESOURCES_OTHER,
    _id: new Types.ObjectId(ids.CR_ME_LIMITED_RESOURCES_OTHER_ID),
};

/**
 * Conciliation
 */
export const CR_CO_OPEN_PENDING = {...cr.CR_CO_OPEN_PENDING, _id: new Types.ObjectId(ids.CR_CO_OPEN_PENDING_ID)};
export const CR_CO_FULL_AGREEMENT = {...cr.CR_CO_FULL_AGREEMENT, _id: new Types.ObjectId(ids.CR_CO_FULL_AGREEMENT_ID)};
export const CR_CO_NO_AGREEMENT = {...cr.CR_CO_NO_AGREEMENT, _id: new Types.ObjectId(ids.CR_CO_NO_AGREEMENT_ID)};
export const CR_CO_PARTIAL_AGREEMENT = {
    ...cr.CR_CO_PARTIAL_AGREEMENT,
    _id: new Types.ObjectId(ids.CR_CO_PARTIAL_AGREEMENT_ID),
};
export const CR_CO_NO_CONTACT = {...cr.CR_CO_NO_CONTACT, _id: new Types.ObjectId(ids.CR_CO_NO_CONTACT_ID)};
export const CR_CO_TOO_FEW_PARTIES = {
    ...cr.CR_CO_TOO_FEW_PARTIES,
    _id: new Types.ObjectId(ids.CR_CO_TOO_FEW_PARTIES_ID),
};
export const CR_CO_CANCELLED_NO_SHOW = {
    ...cr.CR_CO_CANCELLED_NO_SHOW,
    _id: new Types.ObjectId(ids.CR_CO_CANCELLED_NO_SHOW_ID),
};
export const CR_CO_DECLINED = {...cr.CR_CO_DECLINED, _id: new Types.ObjectId(ids.CR_CO_DECLINED_ID)};
export const CR_CO_WITHDRAWN = {...cr.CR_CO_WITHDRAWN, _id: new Types.ObjectId(ids.CR_CO_WITHDRAWN_ID)};
export const CR_CO_DISCONTINUED = {...cr.CR_CO_DISCONTINUED, _id: new Types.ObjectId(ids.CR_CO_DISCONTINUED_ID)};
export const CR_CO_INAPPROPRIATE = {...cr.CR_CO_INAPPROPRIATE, _id: new Types.ObjectId(ids.CR_CO_INAPPROPRIATE_ID)};
export const CR_CO_LIMITED_RESOURCES_CONCILATOR = {
    ...cr.CR_CO_LIMITED_RESOURCES_CONCILATOR,
    _id: new Types.ObjectId(ids.CR_CO_LIMITED_RESOURCES_CONCILATOR_ID),
};
export const CR_CO_LIMITED_RESOURCES_INTERPRETER = {
    ...cr.CR_CO_LIMITED_RESOURCES_INTERPRETER,
    _id: new Types.ObjectId(ids.CR_CO_LIMITED_RESOURCES_INTERPRETER_ID),
};
export const CR_CO_LIMITED_RESOURCES_TECHNOLOGY = {
    ...cr.CR_CO_LIMITED_RESOURCES_TECHNOLOGY,
    _id: new Types.ObjectId(ids.CR_CO_LIMITED_RESOURCES_TECHNOLOGY_ID),
};
export const CR_CO_LIMITED_RESOURCES_SPACE = {
    ...cr.CR_CO_LIMITED_RESOURCES_SPACE,
    _id: new Types.ObjectId(ids.CR_CO_LIMITED_RESOURCES_SPACE_ID),
};
export const CR_CO_LIMITED_RESOURCES_OTHER = {
    ...cr.CR_CO_LIMITED_RESOURCES_OTHER,
    _id: new Types.ObjectId(ids.CR_CO_LIMITED_RESOURCES_OTHER_ID),
};

/**
 * Facilitation
 */
export const CR_FA_OPEN_PENDING = {
    ...cr.CR_FA_OPEN_PENDING,
    _id: new Types.ObjectId(ids.CR_FA_OPEN_PENDING_ID),
};
export const CR_FA_COMPLETED = {
    ...cr.CR_FA_COMPLETED,
    _id: new Types.ObjectId(ids.CR_FA_COMPLETED_ID),
};
export const CR_FA_WITHDRAWN_DISCONTINUED_BEFORE_A_FASCILITATION_SESSION = {
    ...cr.CR_FA_WITHDRAWN_DISCONTINUED_BEFORE_A_FASCILITATION_SESSION,
    _id: new Types.ObjectId(ids.CR_FA_WITHDRAWN_DISCONTINUED_BEFORE_A_FASCILITATION_SESSION_ID),
};
export const CR_FA_WITHDRAWN_DISCONTINUED_AFTER_ONE_OR_MORE_FASCILITATION_SESSION = {
    ...cr.CR_FA_WITHDRAWN_DISCONTINUED_AFTER_ONE_OR_MORE_FASCILITATION_SESSION,
    _id: new Types.ObjectId(ids.CR_FA_WITHDRAWN_DISCONTINUED_AFTER_ONE_OR_MORE_FASCILITATION_SESSION_ID),
};

/**
 * Conflict Coaching
 */
export const CR_CC_OPEN_PENDING = {...cr.CR_CC_OPEN_PENDING, _id: new Types.ObjectId(ids.CR_FA_OPEN_PENDING_ID)};
export const CR_CC_COMPLETED = {...cr.CR_CC_COMPLETED, _id: new Types.ObjectId(ids.CR_CC_COMPLETED_ID)};
export const CR_CC_WITHDRAWN_BEFORE_CONFLICT_COACHING_SESSION = {
    ...cr.CR_CC_WITHDRAWN_BEFORE_CONFLICT_COACHING_SESSION,
    _id: new Types.ObjectId(ids.CR_CC_WITHDRAWN_BEFORE_CONFLICT_COACHING_SESSION_ID),
};
export const CR_CC_WITHDRAWN_AFTER_ONE_OR_MORE_CONFLICT_COACHING_SESSION = {
    ...cr.CR_CC_WITHDRAWN_AFTER_ONE_OR_MORE_CONFLICT_COACHING_SESSION,
    _id: new Types.ObjectId(ids.CR_CC_WITHDRAWN_AFTER_ONE_OR_MORE_CONFLICT_COACHING_SESSION_ID),
};
export const CR_CC_INAPPROPRIATE = {...cr.CR_CC_INAPPROPRIATE, _id: new Types.ObjectId(ids.CR_CC_INAPPROPRIATE_ID)};
export const CR_RPC_OPEN_PENDING = {...cr.CR_RPC_OPEN_PENDING, _id: new Types.ObjectId(ids.CR_RPC_OPEN_PENDING_ID)};

/**
 * Restorative Practices
 */
export const CR_RPC_COMPLETED = {...cr.CR_RPC_COMPLETED, _id: new Types.ObjectId(ids.CR_RPC_COMPLETED_ID)};
export const CR_RPC_AGREEMENT = {...cr.CR_RPC_AGREEMENT, _id: new Types.ObjectId(ids.CR_RPC_AGREEMENT_ID)};
export const CR_RPC_NO_AGREEMENT = {...cr.CR_RPC_NO_AGREEMENT, _id: new Types.ObjectId(ids.CR_RPC_NO_AGREEMENT_ID)};
export const CR_RPC_PARTIAL_AGREEMENT = {
    ...cr.CR_RPC_PARTIAL_AGREEMENT,
    _id: new Types.ObjectId(ids.CR_RPC_PARTIAL_AGREEMENT_ID),
};
export const CR_RPC_WITHDRAWN_BEFORE_RESTORATIVE_CIRCLE = {
    ...cr.CR_RPC_WITHDRAWN_BEFORE_RESTORATIVE_CIRCLE,
    _id: new Types.ObjectId(ids.CR_RPC_WITHDRAWN_BEFORE_RESTORATIVE_CIRCLE_ID),
};
export const CR_RPC_WITHDRAWN_AFTER_ONE_OR_MORE_RESTORATIVE_CIRCLE = {
    ...cr.CR_RPC_WITHDRAWN_AFTER_ONE_OR_MORE_RESTORATIVE_CIRCLE,
    _id: new Types.ObjectId(ids.CR_RPC_WITHDRAWN_AFTER_ONE_OR_MORE_RESTORATIVE_CIRCLE_ID),
};

/**
 * Deliberative Dialogue
 */
export const CR_DD_OPEN_PENDING = {...cr.CR_DD_OPEN_PENDING, _id: new Types.ObjectId(ids.CR_DD_OPEN_PENDING_ID)};
export const CR_DD_COMPLETED = {...cr.CR_DD_COMPLETED, _id: new Types.ObjectId(ids.CR_DD_COMPLETED_ID)};
export const CR_DD_WITHDRAWN = {...cr.CR_DD_WITHDRAWN, _id: new Types.ObjectId(ids.CR_DD_WITHDRAWN_ID)};
/**
 * Other
 */
export const CR_OTH_OPEN_PENDING = {...cr.CR_OTH_OPEN_PENDING, _id: new Types.ObjectId(ids.CR_OTH_OPEN_PENDING_ID)};
export const CR_OTH_COMPLETED = {...cr.CR_OTH_COMPLETED, _id: new Types.ObjectId(ids.CR_OTH_COMPLETED_ID)};
export const CR_OTH_WITHDRAWN = {...cr.CR_OTH_WITHDRAWN, _id: new Types.ObjectId(ids.CR_OTH_WITHDRAWN_ID)};

// Traninig
export const TR_BM_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.TR_BM_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const TR_BM_COMPLETED = {
    _id: new Types.ObjectId(ids.TR_BM_COMPLETED_ID),
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};
export const TR_BM_OTHER = {
    _id: new Types.ObjectId(ids.TR_BM_OTHER_ID),
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const TR_PM_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.TR_PM_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const TR_PM_COMPLETED = {
    _id: new Types.ObjectId(ids.TR_PM_COMPLETED_ID),
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};
export const TR_PM_OTHER = {
    _id: new Types.ObjectId(ids.TR_PM_OTHER_ID),
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};

export const TR_RP_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.TR_RP_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const TR_RP_COMPLETED = {
    _id: new Types.ObjectId(ids.TR_RP_COMPLETED_ID),
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};
export const TR_RP_OTHER = {
    _id: new Types.ObjectId(ids.TR_RP_OTHER_ID),
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};

export const TR_SBW_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.TR_SBW_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const TR_SBW_COMPLETED = {
    _id: new Types.ObjectId(ids.TR_SBW_COMPLETED_ID),
    label: 'Completed',
    description: 'CMC completed the workshop',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};
export const TR_SBW_OTHER = {
    _id: new Types.ObjectId(ids.TR_SBW_OTHER_ID),
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};
export const TR_AT_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.TR_AT_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const TR_AT_COMPLETED = {
    _id: new Types.ObjectId(ids.TR_AT_COMPLETED_ID),
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};
export const TR_AT_OTHER = {
    _id: new Types.ObjectId(ids.TR_AT_OTHER_ID),
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};
export const TR_CC_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.TR_CC_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const TR_CC_COMPLETED = {
    _id: new Types.ObjectId(ids.TR_CC_COMPLETED_ID),
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};

export const TR_CC_OTHER = {
    _id: new Types.ObjectId(ids.TR_CC_OTHER_ID),
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};

export const TR_OTH_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.TR_OTH_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const TR_OTH_COMPLETED = {
    _id: new Types.ObjectId(ids.TR_OTH_COMPLETED_ID),
    label: 'Completed',
    description: 'CMC completed the training',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed training action to select this disposition.',
};

export const TR_OTH_OTHER = {
    _id: new Types.ObjectId(ids.TR_OTH_OTHER_ID),
    label: 'Other ',
    description: '',
    closed: true,
    errorMessage: '',
};

export const OUT_RE_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.OUT_RE_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OUT_RE_COMPLETED = {
    _id: new Types.ObjectId(ids.OUT_RE_COMPLETED_ID),
    label: 'Completed',
    description: 'CMC completed Re-entry Info Session',
    closed: true,
    errorMessage: '',
};
export const OUT_RE_CANCELED = {
    _id: new Types.ObjectId(ids.OUT_RE_CANCELED_ID),
    label: 'Canceled',
    description: 'Re-entry Info Session canceled',
    closed: true,
    errorMessage: '',
};

export const OUT_OTH_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.OUT_OTH_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const OUT_OTH_COMPLETED = {
    _id: new Types.ObjectId(ids.OUT_OTH_COMPLETED_ID),
    label: 'Completed',
    description: 'CMC completed outreach',
    closed: true,
    errorMessage: '',
};

export const OUT_OTH_CANCELLED = {
    _id: new Types.ObjectId(ids.OUT_OTH_CANCELLED_ID),
    label: 'Canceled',
    description: 'CMC or partnering entity canceled outreach',
    closed: true,
    errorMessage: '',
};

export const OUT_OTH_OTHER = {
    _id: new Types.ObjectId(ids.OUT_OTH_OTHER_ID),
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const VSM_MEN_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.VSM_MEN_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const VSM_MEN_COMPLETED = {
    _id: new Types.ObjectId(ids.VSM_MEN_COMPLETED_ID),
    label: 'Completed',
    description: 'Mentoring activity completed',
    closed: true,
    errorMessage: '',
};

export const VSM_MEN_CANCELLED = {
    _id: new Types.ObjectId(ids.VSM_MEN_CANCELLED_ID),
    label: 'Canceled',
    description: 'Mentoring activity canceled',
    closed: true,
    errorMessage: '',
};

export const VSM_EVA_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.VSM_EVA_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const VSM_EVA_COMPLETED = {
    _id: new Types.ObjectId(ids.VSM_EVA_COMPLETED_ID),
    label: 'Completed',
    description: 'Evaluation activity completed',
    closed: true,
    errorMessage: '',
};

export const VSM_EVA_CANCELLED = {
    _id: new Types.ObjectId(ids.VSM_EVA_CANCELLED_ID),
    label: 'Canceled',
    description: 'Evaluation activity canceled',
    closed: true,
    errorMessage: '',
};

export const VSM_OTH_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.VSM_OTH_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const VSM_OTH_COMPLETED = {
    _id: new Types.ObjectId(ids.VSM_OTH_COMPLETED_ID),
    label: 'Other',
    description: 'Activity completed',
    closed: true,
    errorMessage: '',
};
export const VSM_OTH_OTHER = {
    _id: new Types.ObjectId(ids.VSM_OTH_OTHER_ID),
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};
export const OE_BM_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.OE_BM_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OE_BM_COMPLETED = {
    _id: new Types.ObjectId(ids.OE_BM_COMPLETED_ID),
    label: 'Completed',
    description: 'Board meeting has been held',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed meeting action to select this disposition.',
};

export const OE_BM_CANCELLED = {
    _id: new Types.ObjectId(ids.OE_BM_CANCELLED_ID),
    label: 'Canceled',
    description: 'Board meeting was canceled',
    closed: true,
    errorMessage: '',
};

export const OE_AM_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.OE_AM_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OE_AM_COMPLETED = {
    _id: new Types.ObjectId(ids.OE_AM_COMPLETED_ID),
    label: 'Completed',
    description: 'Annual meeting has been held',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed meeting action to select this disposition.',
};

export const OE_AM_CANCELLED = {
    _id: new Types.ObjectId(ids.OE_AM_CANCELLED_ID),
    label: 'Canceled',
    description: 'Annual meeting was canceled',
    closed: true,
    errorMessage: '.',
};

export const OE_CM_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.OE_CM_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '.',
};

export const OE_CM_COMPLETED = {
    _id: new Types.ObjectId(ids.OE_CM_COMPLETED_ID),
    label: 'Completed',
    description: 'Committee meeting has been held',
    closed: true,
    errorMessage: 'Invalid choice. You need at least one completed meeting action to select this disposition.',
};
export const OE_CM_CANCELLED = {
    _id: new Types.ObjectId(ids.OE_CM_CANCELLED_ID),
    label: 'Canceled',
    description: 'Committee meeting was canceled',
    closed: true,
    errorMessage: '',
};

export const OE_SP_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.OE_SP_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OE_SP_COMPLETED = {
    _id: new Types.ObjectId(ids.OE_SP_COMPLETED_ID),
    label: 'Completed',
    description: 'Strategic planning completed',
    closed: true,
    errorMessage: '',
};
export const OE_SP_CANCELLED = {
    _id: new Types.ObjectId(ids.OE_SP_CANCELLED_ID),
    label: 'Canceled',
    description: 'Strategic planning canceled',
    closed: true,
    errorMessage: '',
};
export const OE_EV_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.OE_EV_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const OE_EV_COMPLETED = {
    _id: new Types.ObjectId(ids.OE_EV_COMPLETED_ID),
    label: 'Completed',
    description: 'Event completed',
    closed: true,
    errorMessage: '',
};
export const OE_EV_CANCELLED = {
    _id: new Types.ObjectId(ids.OE_EV_CANCELLED_ID),
    label: 'Canceled',
    description: 'Event canceled',
    closed: true,
    errorMessage: '',
};
export const OE_OTH_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.OE_OTH_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OE_OTH_COMPLETED = {
    _id: new Types.ObjectId(ids.OE_OTH_COMPLETED_ID),
    label: 'Completed',
    description: 'Event completed',
    closed: true,
    errorMessage: '',
};
export const OE_OTH_OTHER = {
    _id: new Types.ObjectId(ids.OE_OTH_OTHER_ID),
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const ON_OTH_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.ON_OTH_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const ON_OTH_ATTENDED = {
    _id: new Types.ObjectId(ids.ON_OTH_ATTENDED_ID),
    label: 'Attended',
    description: 'Attended organizational networking event',
    closed: true,
    errorMessage: '',
};

export const ON_OTH_OTHER = {
    _id: new Types.ObjectId(ids.ON_OTH_OTHER_ID),
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const OD_GW_INPROCESS = {
    _id: new Types.ObjectId(ids.OD_GW_INPROCESS_ID),
    label: 'In process',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OD_GW_SUBMITTED = {
    _id: new Types.ObjectId(ids.OD_GW_SUBMITTED_ID),
    label: 'Submitted',
    description: 'Grant submitted',
    closed: true,
    errorMessage: '',
};

export const OD_GW_ACCEPTED = {
    _id: new Types.ObjectId(ids.OD_GW_ACCEPTED_ID),
    label: 'Accepted',
    description: 'Grant accepted',
    closed: true,
    errorMessage: '',
};

export const OD_GW_REJECTED = {
    _id: new Types.ObjectId(ids.OD_GW_REJECTED_ID),
    label: 'Rejected',
    description: 'Grant rejected',
    closed: true,
    errorMessage: '',
};

export const OD_GR_ONGOING = {
    _id: new Types.ObjectId(ids.OD_GR_ONGOING_ID),
    label: 'Ongoing',
    description: 'In process',
    closed: false,
    errorMessage: '',
};

export const OD_GR_COMPLETED = {
    _id: new Types.ObjectId(ids.OD_GR_COMPLETED_ID),
    label: 'Completed',
    description: 'Grant research completed',
    closed: true,
    errorMessage: '',
};
export const OD_GM_ONGOING = {
    _id: new Types.ObjectId(ids.OD_GM_ONGOING_ID),
    label: 'Ongoing',
    description: 'Managing current grant',
    closed: false,
    errorMessage: '',
};

export const OD_GM_CLOSED = {
    _id: new Types.ObjectId(ids.OD_GM_CLOSED_ID),
    label: 'Closed',
    description: 'Grant cycle closed',
    closed: true,
    errorMessage: '',
};

export const OD_FR_PLANNING = {
    _id: new Types.ObjectId(ids.OD_FR_PLANNING_ID),
    label: 'Planning',
    description: 'Fundraising is in planning stage',
    closed: false,
    errorMessage: '',
};

export const OD_FR_ONGOING = {
    _id: new Types.ObjectId(ids.OD_FR_ONGOING_ID),
    label: 'Ongoing',
    description: 'Fundraising activity has been launched and is in process',
    closed: false,
    errorMessage: '',
};

export const OD_FR_CLOSED = {
    _id: new Types.ObjectId(ids.OD_FR_CLOSED_ID),
    label: 'Closed',
    description: '',
    closed: true,
    errorMessage: '',
};
export const OD_OTH_ONGOING = {
    _id: new Types.ObjectId(ids.OD_OTH_ONGOING_ID),
    label: 'Ongoing',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const OD_OTH_CLOSED = {
    _id: new Types.ObjectId(ids.OD_OTH_CLOSED_ID),
    label: 'Closed',
    description: '',
    closed: true,
    errorMessage: '',
};
export const OD_OTH_OTHER = {
    _id: new Types.ObjectId(ids.OD_OTH_OTHER_ID),
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};

export const ME_PMPQM_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.ME_PMPQM_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'PMP meeting scheduled',
    closed: false,
    errorMessage: '',
};

export const ME_PMPQM_COMPLETED = {
    _id: new Types.ObjectId(ids.ME_PMPQM_COMPLETED_ID),
    label: 'Completed',
    description: 'PMP meeting held',
    closed: true,
    errorMessage: '',
};

export const ME_PMPQM_CANCELLED = {
    _id: new Types.ObjectId(ids.ME_PMPQM_CANCELLED_ID),
    label: 'Canceled',
    description: 'PMP meeting canceled',
    closed: true,
    errorMessage: '',
};
export const OT_OT_OPEN_PENDING = {
    _id: new Types.ObjectId(ids.OT_OT_OPEN_PENDING_ID),
    label: 'Open/Pending',
    description: 'In process',
    closed: false,
    errorMessage: '',
};
export const OT_OT_COMPLETED = {
    _id: new Types.ObjectId(ids.OT_OT_COMPLETED_ID),
    label: 'Completed',
    description: 'Activity completed',
    closed: true,
    errorMessage: '',
};
export const OT_OT_OTHER = {
    _id: new Types.ObjectId(ids.OT_OT_OTHER_ID),
    label: 'Other',
    description: '',
    closed: true,
    errorMessage: '',
};
